<template>
    <div v-if="bizAuth.onOrOffShelf.hasRight" class="page-setting has-bc parent-frame batch-policy" :class="{'fixed': listIsFixed}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>
                {{$route.meta.title}}({{batchListTotal}})
                <word-tips-hover data="以下列表為已完善、下架房源，並且最快起租日均調整為租約到期後一天。" width="514px"></word-tips-hover>
            </h1>
            <div class="btn-group" v-if="hasSeletedHouse">
                <div class="default-button publish" @click="batchPublish">
                    上架
                </div>
            </div>
        </div>
        <batch-publish-comp></batch-publish-comp>
    </div>
</template>
<script>
import batchPublishComp from '@/components/bussiness/mgtCategory/houseMgt/batchPublish/batchPublishComp.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';

import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
        this.$store.dispatch('getBizLandlordPolicyList')
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.onOrOffShelf.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
        batchPublish: function () {
            this.$analyticsBiz.logEvent('批量設定上架', { screen_name: '批量設定上架'})
            this.$store.dispatch('updateBizBatchPublish')
            .then(()=>{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '成功上架房源',type: 'success'})
            })
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            hasSeletedHouse: 'GET_BIZ_BATCH_PUBLISH_HAS_SELECTED_HOUSE',
            batchListTotal: 'GET_BIZ_BATCH_PUBLISH_LIST_TOTAL'
        })
    },
    components: {
        batchPublishComp,
        wordTipsHover
    }
}
</script>
<style lang="scss" >
    .batch-policy{
        &.page-setting.fixed .table-list .table-list-title {
            width: 819px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseMgt/batchPublish.vue